<template>
  <v-container fluid class="fill-height">
    <template v-if="!initFlag">
      <v-skeleton-loader type="article"></v-skeleton-loader>
    </template>
    <template v-else>
      <v-row dense class="fill-height">
        <v-col cols="7">
          <v-card tile class="fill-height">
            <v-card-text class="pa-0">
              <!-- 工具详情 -->
              <v-card flat>
                <v-card-title class="pl-1">
                  <v-icon color="teal" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>工具说明
                </v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="2">
                      <v-row justify="center">
                        <v-col cols="auto">
                          <v-img :src="Utility.RES_SERVER+tool.logo" contain width="80" />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="10">
                      <v-row dense>
                        <v-col cols="12">
                          <span class="text-h6">{{tool.name}}</span>
                          <span class="caption ml-3 deep-orange--text">版本号:{{tool.version}}</span>
                          <v-btn x-small outlined color="primary" class="ml-3 mt-0 pl-1 pr-1" @click="onFav">
                            <v-icon color="red" x-small>{{!tool.userFavId ? 'mdi-heart-outline' : 'mdi-heart'}}</v-icon>
                            <span v-if="tool.favNum>0" class="ml-1 red--text caption">{{tool.favNum}}</span>
                          </v-btn>
                        </v-col>
                        <v-col cols="12" class="text-caption">{{tool.note}}</v-col>
                        <v-col cols="12" class="text-button deep-orange--text">{{tool.point==0?`限时免费`:`所需积分:${tool.point}`}}</v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- 样本数据采集 -->
              <v-card flat :disabled="!token">
                <v-card-title class="pl-1">
                  <v-icon color="teal" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>参数设置
                </v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="6">
                      <v-text-field placeholder="请输入任务描述(选填)" single-line dense outlined v-model="mark" hide-details></v-text-field>
                    </v-col>
                  </v-row>
                  <tool-sample-data-form ref="toolSampleDataForm" :tool="tool"></tool-sample-data-form>
                  <analyse-param-form v-if="toolParams.length" ref="toolParamForm" :wid="tool.id" :items="toolParams" :coder="coder"></analyse-param-form>
                </v-card-text>
              </v-card>

              <!-- 按钮区域 -->
              <v-card flat>
                <v-card-text>
                  <v-row dense v-if="!!token">
                    <v-col cols="auto">
                      <v-btn :disabled="!tool.status" color="primary" class="ml-4 mt-2" @click="onExecute" v-one-click>运 行</v-btn>
                      <span style="color:#FF0000">*工具已被下架，不能提交新的任务</span>
                    </v-col>
                  </v-row>
                  <v-row dense v-else>
                    <v-col cols="auto">
                      <v-btn color="primary" :to="`/login?redirect=${$router.currentRoute.fullPath}`">登 录</v-btn>
                      <span class="ml-2 caption warning--text">请登录后使用此分析工具</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

            </v-card-text>
          </v-card>
        </v-col>

        <!-- 右侧说明 -->
        <v-col cols="5">
          <v-card tile class="fill-height">
            <v-card-text>
              <tool-help-tab v-if="toolHelps.length" :tool-id="tool.id" :items="toolHelps"></tool-help-tab>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
import { getTool, runToolTask, favTool } from '@/plugins/api';
import ToolSampleDataForm from '@/views/Component/ToolSampleDataForm.vue';
import AnalyseParamForm from '@/views/Component/AnalyseParamForm.vue';
import ToolHelpTab from '@/views/Component/ToolHelpTab.vue';
import { mapState } from 'vuex';

export default {
  data () {
    return {
      initFlag: false,
      id: null,
      billData: {},

      paramData: {},
      mark: '',
      taskId: ''
    }
  },
  computed: {
    ...mapState({ token: state => state.token }),
    tool () { return this.billData.tool },
    toolParams () { return this.billData.params || [] },
    toolHelps () { return this.billData.helps || [] },
    coder () { return this.billData.coder }
  },
  watch: {
    '$route.params.id' (value) {
      if (value && this.$router.currentRoute.fullPath == `/tool/${value}`) this.init();
    }
  },
  methods: {
    onExecute () { // 后台根据数据参数进行获取，然后记录分析任务
      if (!this.$refs.toolSampleDataForm.validate()) return;
      let paramItems;
      if (this.toolParams.length) {
        if (!this.$refs.toolParamForm.validate()) return;
        paramItems = this.$refs.toolParamForm.getBillData();
      }
      let billData = this.$refs.toolSampleDataForm.getBillData();
      billData.append('toolId', this.id);
      billData.append('mark', this.mark);
      // 进行非法字符校验
      if (paramItems) billData.append('items', JSON.stringify(paramItems)); // 由于可能涉及到文件上传,后端只能使用request获取输入参数，不能自动匹配数据参数类型
      runToolTask(billData).then((res) => {
        let taskId = res.data;
        this.$router.push('/tool/task/' + taskId);
      })
    },
    // dataValidate(billData){

    // },
    init () {
      this.id = this.$route.params && this.$route.params.id;
      if (!this.id) return;
      this.initFlag = false;
      getTool(this.id).then(res => {
        this.billData = res.data;
        this.initFlag = true;
      })
    },
    onFav () {
      if (!this.token) {
        this.$router.push(`/login?redirect=/tool/${this.id}`);
      } else {
        favTool(this.id).then((res) => {
          let msg = this.tool.userFavId ? '取消收藏成功' : '加入收藏成功';
          this.$message.success(msg);
          this.tool.favNum = res.data.favNum;
          this.tool.userFavId = res.data.userFavId;
        })
      }
    }
  },
  created () {
    this.init();
  },
  components: { ToolSampleDataForm, AnalyseParamForm, ToolHelpTab }
}
</script>